import { Box, Text, dimensions } from '@factorialco/deprecated-design-system'

import DocumentType from 'modules/core/components/DocumentType'
import i18n from 'modules/core/lib/i18n'

interface Props {
  files: File[]
}

export const Files = ({ files }: Props) => {
  if (files.length === 0) return null

  return (
    <>
      <Box paddingY="s16">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('project_management.tasks.form.labels.files')}
        </Text.Normal>
      </Box>
      {files.map((file: File, index: number) => {
        const isImage = file.type?.includes('image') || file.type?.includes('image')
        const src = URL.createObjectURL(new Blob([file]))

        return (
          <Box key={index}>
            <Box
              background="grey000White"
              borderRadius={{ all: 'abs008' }}
              gap="s12"
              paddingX="s24"
              paddingY="s16"
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
              flexDirection="row"
              alignItems="center"
              justifyContent="spaceBetween"
            >
              <Box flexDirection="row" alignItems="center" gap="s12">
                {isImage ? (
                  <Box width="s80" height="s48">
                    <img
                      src={src}
                      alt={file.name}
                      style={{ maxWidth: dimensions.s80, maxHeight: dimensions.s48 }}
                    />
                  </Box>
                ) : (
                  <DocumentType mimetype={file.type} />
                )}

                <Text.Normal weight="medium" color="grey800" size="300" overflowWrap>
                  {file.name}
                </Text.Normal>
              </Box>
            </Box>
          </Box>
        )
      })}
    </>
  )
}
